// Add here the components that you want to bootstrap on PHP pages
import { TrackingComponent } from '@freelancer/tracking';
import { NavigationSecondaryAboutComponent } from '../app/navigation/navigation-secondary/navigation-secondary-about.component';
import { NavigationSecondaryCommunityComponent } from '../app/navigation/navigation-secondary/navigation-secondary-community.component';
import { NavigationSecondaryContestsComponent } from '../app/navigation/navigation-secondary/navigation-secondary-contests.component';
import { NavigationSecondaryFinancesComponent } from '../app/navigation/navigation-secondary/navigation-secondary-finances.component';
import { NavigationSecondaryHelpComponent } from '../app/navigation/navigation-secondary/navigation-secondary-help.component';
import { NavigationSecondaryHireFreelancersComponent } from '../app/navigation/navigation-secondary/navigation-secondary-hire-freelancers.component';
import { NavigationSecondaryLocalJobsComponent } from '../app/navigation/navigation-secondary/navigation-secondary-local-jobs.component';
import { NavigationSecondaryMySkillsComponent } from '../app/navigation/navigation-secondary/navigation-secondary-my-skills.component';
import { NavigationSecondaryPortfolioComponent } from '../app/navigation/navigation-secondary/navigation-secondary-portfolio.component';
import { NavigationSecondaryProfileComponent } from '../app/navigation/navigation-secondary/navigation-secondary-profile.component';
import { NavigationSecondaryProjectsComponent } from '../app/navigation/navigation-secondary/navigation-secondary-projects.component';
import { NavigationSecondaryShowcaseComponent } from '../app/navigation/navigation-secondary/navigation-secondary-showcase.component';
import { CompatABTestComponent } from './compat-abtest.component';
import { CompatLocalStorageComponent } from './compat-local-storage.component';
import { CompatMessagingComponent } from './compat-messaging.component';
import { CompatModalsComponent } from './compat-modals.component';
import { CompatNavigationEmptyComponent } from './compat-navigation-empty.component';
import { CompatNavigationComponent } from './compat-navigation.component';
import { CompatTasklistComponent } from './compat-tasklist.component';
import { CompatThreatmetrixComponent } from './compat-threatmetrix.component';

export const components = [
  {
    selector: 'webapp-compat-tracking',
    loadChildren: '@freelancer/tracking/tracking.module#TrackingModule',
    component: TrackingComponent,
    path: 'hack_path_not_used',
  },
  {
    selector: 'webapp-compat-navigation',
    loadChildren: 'compat/compat-navigation.module#CompatNavigationModule',
    component: CompatNavigationComponent,
    path: 'hack_path_not_used_index_0',
  },
  {
    selector: 'webapp-compat-navigation-empty',
    loadChildren:
      'compat/compat-navigation-empty.module#CompatNavigationEmptyModule',
    component: CompatNavigationEmptyComponent,
    path: 'hack_path_not_used_index_0',
  },
  {
    selector: 'webapp-compat-navigation-secondary-projects',
    loadChildren:
      'app/navigation/navigation-secondary/navigation-secondary-projects.module#NavigationSecondaryProjectsModule',
    component: NavigationSecondaryProjectsComponent,
    path: 'hack_path_not_used',
  },
  {
    selector: 'webapp-compat-navigation-secondary-about',
    loadChildren:
      'app/navigation/navigation-secondary/navigation-secondary-about.module#NavigationSecondaryAboutModule',
    component: NavigationSecondaryAboutComponent,
    path: 'hack_path_not_used',
  },
  {
    selector: 'webapp-compat-navigation-secondary-contests',
    loadChildren:
      'app/navigation/navigation-secondary/navigation-secondary-contests.module#NavigationSecondaryContestsModule',
    component: NavigationSecondaryContestsComponent,
    path: 'hack_path_not_used',
  },
  {
    selector: 'webapp-compat-navigation-secondary-community',
    loadChildren:
      'app/navigation/navigation-secondary/navigation-secondary-community.module#NavigationSecondaryCommunityModule',
    component: NavigationSecondaryCommunityComponent,
    path: 'hack_path_not_used',
  },
  {
    selector: 'webapp-compat-navigation-secondary-profile',
    loadChildren:
      'app/navigation/navigation-secondary/navigation-secondary-profile.module#NavigationSecondaryProfileModule',
    component: NavigationSecondaryProfileComponent,
    path: 'hack_path_not_used',
  },
  {
    selector: 'webapp-compat-navigation-secondary-showcase',
    loadChildren:
      'app/navigation/navigation-secondary/navigation-secondary-showcase.module#NavigationSecondaryShowcaseModule',
    component: NavigationSecondaryShowcaseComponent,
    path: 'hack_path_not_used',
  },
  {
    selector: 'webapp-compat-navigation-secondary-portfolio',
    loadChildren:
      'app/navigation/navigation-secondary/navigation-secondary-portfolio.module#NavigationSecondaryPortfolioModule',
    component: NavigationSecondaryPortfolioComponent,
    path: 'hack_path_not_used',
  },
  {
    selector: 'webapp-compat-navigation-secondary-local-jobs',
    loadChildren:
      'app/navigation/navigation-secondary/navigation-secondary-local-jobs.module#NavigationSecondaryLocalJobsModule',
    component: NavigationSecondaryLocalJobsComponent,
    path: 'hack_path_not_used',
  },
  {
    selector: 'webapp-compat-navigation-secondary-finances',
    loadChildren:
      'app/navigation/navigation-secondary/navigation-secondary-finances.module#NavigationSecondaryFinancesModule',
    component: NavigationSecondaryFinancesComponent,
    path: 'hack_path_not_used',
  },
  {
    selector: 'webapp-compat-navigation-secondary-my-skills',
    loadChildren:
      'app/navigation/navigation-secondary/navigation-secondary-my-skills.module#NavigationSecondaryMySkillsModule',
    component: NavigationSecondaryMySkillsComponent,
    path: 'hack_path_not_used',
  },
  {
    selector: 'webapp-compat-navigation-secondary-hire-freelancers',
    loadChildren:
      'app/navigation/navigation-secondary/navigation-secondary-hire-freelancers.module#NavigationSecondaryHireFreelancersModule',
    component: NavigationSecondaryHireFreelancersComponent,
    path: 'hack_path_not_used',
  },
  {
    selector: 'webapp-compat-navigation-secondary-help',
    loadChildren:
      'app/navigation/navigation-secondary/navigation-secondary-help.module#NavigationSecondaryHelpModule',
    component: NavigationSecondaryHelpComponent,
    path: 'hack_path_not_used',
  },
  {
    selector: 'webapp-compat-messaging',
    loadChildren: 'compat/compat-messaging.module#CompatMessagingModule',
    component: CompatMessagingComponent,
    path: 'hack_path_not_used',
  },
  {
    selector: 'webapp-compat-modals',
    loadChildren: 'compat/compat-modals.module#CompatModalsModule',
    component: CompatModalsComponent,
    path: 'hack_path_not_used',
  },
  {
    selector: 'webapp-compat-abtest',
    loadChildren: 'compat/compat-abtest.module#CompatABTestModule',
    component: CompatABTestComponent,
    path: 'hack_path_not_used',
  },
  {
    selector: 'webapp-compat-tasklist',
    loadChildren: 'compat/compat-tasklist.module#CompatTasklistModule',
    component: CompatTasklistComponent,
    path: 'hack_path_not_used',
  },
  {
    selector: 'webapp-compat-threatmetrix',
    loadChildren: 'compat/compat-threatmetrix.module#CompatThreatmetrixModule',
    component: CompatThreatmetrixComponent,
    path: 'hack_path_not_used',
  },
  {
    selector: 'webapp-compat-local-storage',
    component: CompatLocalStorageComponent,
    loadChildren: 'compat/compat-local-storage.module#CompatLocalStorageModule',
    path: 'hack_path_not_used',
  },
];
